import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthStore } from '../store/auth.store';

/**
 * Guard del detalle de subasta (`/auctions/:id`). El KYC es obligatorio para
 * acceder/pujar: si la verificación KYC está habilitada y el customer no está
 * aprobado, informa, redirige a /settings/kyc y bloquea el acceso. Comparte
 * mensaje y redirección con AuthStore.ensureKycApprovedForAuction, alineado con
 * la exigencia del backend en `placeBid`.
 */
export const kycApprovedForAuctionGuard: CanActivateFn = () => {
  return inject(AuthStore).ensureKycApprovedForAuction();
};
